import React from "react";
import PropTypes from "prop-types";
import { KlarnaLogo } from "../../SVGs";
import "./Klarna.scss";

const Klarna = (props) => (
  <div className="Klarna">
    <KlarnaLogo />
    {props.text}
  </div>
);

Klarna.propTypes = {
  text: PropTypes.string,
};

export default Klarna;
